<template>
  <AiEventComponent />
</template>

<script>
import AiEventComponent from '@/components/event/AiEventComponent.vue';

export default {
  components: {
    AiEventComponent,
  },
  data() {
    return {

    };
  },
  methods: {

  },
};
</script>